module.exports = __webpack_public_path__ + "img/m3.e670f745.jpg";